<script setup>
import { computed } from 'vue'

const props = defineProps({
  name: { type: String, required: true },
  desc: { type: String, default: '' },
  // explainer(做不到/不可写/不可读)页:desc 原文当副标题,不拼"no sign-up"尾巴、不显"100% FREE"徽标
  // —— 那些对"这个转换做不了"的页不合适,也避免和下方红色 verdict 重复推销。
  plain: { type: Boolean, default: false }
})

// H1 — verbatim from seo.js:23: wrap a trailing "to …" in <span class="hl">.
// Use v-html so the space before "to" is preserved (Vue template whitespace eats it).
const heroH1 = computed(() =>
  (props.name || '').replace(/(\bto\b.*)$/i, '<span class="hl">$1</span>')
)

// Subtitle transform — verbatim from seo.js:24:
//   desc.replace(/^Free online\s+/,'').replace(/\s*— no sign-up.*$/,'').replace(/\.$/,'')
//     + '. No sign-up, no watermark, 100% private.'
const subtitle = computed(() => {
  if (props.plain) return props.desc || ''; // explainer:原文,不加尾巴
  return (props.desc || '')
    .replace(/^Free online\s+/, '')
    .replace(/\s*— no sign-up.*$/, '')
    .replace(/\.$/, '') + '. No sign-up, no watermark, 100% private.';
})
</script>

<template>
  <section class="tool-hero">
    <div class="wrap">
      <div v-if="!plain" class="tool-badge">
        <span class="tb-ico">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M5 13l4 4L19 7" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </span>100% FREE · NO SIGN-UP
      </div>
      <h1 v-html="heroH1"></h1>
      <p>{{ subtitle }}</p>
    </div>
  </section>
</template>
